import { Navigate } from "react-router-dom";
import AdminMainLayout from "../../layouts/AdminLayout/AdminMainLayout";
import AdminLogin from "../../modules/Admin/AdminAuth/AdminLogin";
import AdminDashboard from "../../modules/Admin/AdminDashboard";
import AdminInventory from "../../modules/Admin/Inventory Mangement/AdminInventory";
import AdminPrivateRoute from "./AdminPrivateRoute";
import AdminRearrangeUiScreen from "../../modules/Admin/AdminRearrangeUiScreen";
import AdminCreateBundlesScreen from "../../modules/Admin/Offer Management/AdminCreateBundlesScreen";
import AdminBundleScreen from "../../modules/Admin/Offer Management/AdminBundleScreen";
import CreateSlotsScreen from "../../modules/Admin/CreateSlotsScreen";
import ManageServices from "../../modules/Admin/Services/ManageServices";
import ManagePackages from "../../modules/Admin/Services/ManagePackages";
import ManageWeekdays from "../../modules/Admin/Services/ManageWeekdays";
import ManageBookings from "../../modules/Admin/Services/ManageBookings";
import AdminPetAddScreen from "../../modules/Admin/Pets/AdminPetAddScreen";
import AdminCreateNewBanner from "../../modules/Admin/Offer Management/AdminCreateNewBanner";
import AdminBrandAddScreen from "../../modules/Admin/Products/AdminBrandAddScreen";
import AdminProductManagement from "../../modules/Admin/Products/AdminProductMangement";
import AdminProductEditScreen from "../../modules/Admin/Products/AdminProductEditScreen";
import AdminProductAddScreen from "../../modules/Admin/Products/AdminProductAddScreen";
import AdminFreeProductScreen from "../../modules/Admin/Offer Management/AdminFreeProductScreen";
import AdminCreateFreeProductScreen from "../../modules/Admin/Offer Management/AdminCreateFreeProductScreen";
import AdminBannerInnerSection from "../../modules/Admin/Offer Management/AdminBannerInnerSection";
import AdminAdBanner from "../../modules/Admin/Offer Management/AdminAdBanner";
import AdminPetScreen from "../../modules/Admin/Pets/AdminPetScreen";
import AdminPetEditScreen from "../../modules/Admin/Pets/AdminPetEditScreen";
import AdminBrandScreen from "../../modules/Admin/Products/AdminBrandsScreen";
import ManageOffers from "../../modules/Admin/Services/ManageOffers";
import CareersManagement from "../../modules/Admin/Footer Management/CareersManagement";
import CategoriesManagement from "../../modules/Admin/Category Management/CategoriesManagement";
import AddNewSubCategory from "../../modules/Admin/Category Management/AddNewSubCategory";
import InventoryUploadsScreen from "../../modules/Admin/Inventory Mangement/InventoryUploadsScreen";
import ManageAddOns from "../../modules/Admin/Services/ManageAddOns";
import AdminOrdersDashboard from "../../modules/Admin/Order Management/AdminOrdersDashboard";
import AddNewCareersScreen from "../../modules/Admin/Footer Management/AddNewCareersScreen";
import BlogManagement from "../../modules/Admin/Footer Management/BlogManagement";
import AddNewBlogScreen from "../../modules/Admin/Footer Management/AddNewBlogScreen";
import { FAQAdmin } from "../../modules/Admin/Footer Management/FAQAdmin";
import { TermsAdmin } from "../../modules/Admin/Footer Management/TermsAndConditions";
import NotFound from "../../modules/NotFound";
import CouponManagement from "../../modules/Admin/Offer Management/CouponManagement";
import AdminSubscriptionOrders from "../../modules/Admin/Order Management/AdminSubscriptionOrders";
import AdminOrderServices from "../../modules/Admin/Order Services/AdminBookingService";
import AdminSettings from "../../modules/Admin/AdminSettings/AdminSettings";

import { PetlandAbandonedCartScreen } from "../../modules/Admin/CustomerManagement/PetlandAbandonedCartScreen";
import { PetlandCustomerAdminScreen } from "../../modules/Admin/CustomerManagement/PetlandCustomerAdminScreen";
import CreateBookingScreen from "../../modules/Admin/Services/CreateBookingScreen";
import AdminBookingService from "../../modules/Admin/Order Services/AdminBookingService";
import ManageEmployees from "../../modules/Admin/Services/ManageEmployees";
import EmailTemplatesScreen from "../../modules/Admin/AdminEmailTemplates/EmailTemplatesScreen";
import EmailTemplateDetailsScreen from "../../modules/Admin/AdminEmailTemplates/EmailTemplateDetailsScreen";
import AdminQueriesScreen from "../../modules/Admin/Footer Management/AdminQueriesScreen";
import EmailManagementScreen from "../../components/Admin/EmailTemplates/EmailManagementScreen";
import BrandingProfileDetailsScreen from "../../modules/Admin/AdminEmailTemplates/BrandingProfileDetailsScreen";
import EmailLayoutDetailsScreen from "../../modules/Admin/AdminEmailTemplates/EmailLayoutDetailsScreen";
import EmailCategoryDetailsScreen from "../../modules/Admin/AdminEmailTemplates/EmailCategoryDetailsScreen";
import HomeSectionsScreen from "../../modules/Admin/RearrangeUi/HomeSectionsScreen";
import SectionFormScreen from "../../modules/Admin/RearrangeUi/SectionFormScreen";
import ManageSectionItemsScreen from "../../modules/Admin/RearrangeUi/ManageSectionItemsScreen";
import SectionPreviewScreen from "../../modules/Admin/RearrangeUi/SectionPreviewScreen";
import AdminAnalytics from "../../modules/Admin/AdminAnalytics";
const AdminRoutes = [
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <AdminPrivateRoute />,
    children: [
      {
        element: <AdminMainLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="admindashboard" replace />,
          },
          {
            path: "admindashboard",
            element: <AdminDashboard />,
          },
          {
            path: "analytics",
            element: <AdminAnalytics />,
          },
          {
            path: "product/inventoryupload",
            element: <AdminInventory />,
          },
          {
            path: "AdminOrdersDashboard",
            element: <AdminOrdersDashboard />,
          },

          {
            path: "AdminSubscriptionOrders",
            element: <AdminSubscriptionOrders />,
          },
          {
            path: "product/inventoryupload/inventoryalluploadscreen",
            element: <InventoryUploadsScreen />,
          },

          {
            path: "product/productmanagement",
            element: <AdminProductManagement />,
          },
          {
            path: "product/productmanagement/producteditscreen/:id",
            element: <AdminProductEditScreen />,
          },
          {
            path: "product/addbrand",
            element: <AdminBrandScreen />,
          },
          {
            path: "product/addbrand/addnewBrand",
            element: <AdminBrandAddScreen />,
          },
          {
            path: "product/addproduct",
            element: <AdminProductAddScreen />,
          },
          {
            path: "services/ManageBookings",
            element: <ManageBookings />,
          },
          {
            path: "services/ManageBookings/CreateBookingScreen",
            element: <CreateBookingScreen />,
          },
          {
            path: "services/ManageServices",
            element: <ManageServices />,
          },
          {
            path: "services/ManageEmployees",
            element: <ManageEmployees />,
          },
          {
            path: "services/ManageWeekdays",
            element: <ManageWeekdays />,
          },
          {
            path: "services/ManagePackages",
            element: <ManagePackages />,
          },
          {
            path: "services/ManageOffers",
            element: <ManageOffers />,
          },
          {
            path: "services/addOns",
            element: <ManageAddOns />,
          },
          {
            path: "CreateSlotsScreen",
            element: <CreateSlotsScreen />,
          },
          // {
          //   path: "uiconfigure",
          //   element: <AdminRearrangeUiScreen />,
          // },
          {
            path: "uiconfigure/sections",
            element: <HomeSectionsScreen />,
          },
          {
            path: "uiconfigure/sections/new",
            element: <SectionFormScreen />,
          },
          {
            path: "uiconfigure/sections/:sectionId/edit",
            element: <SectionFormScreen />,
          },
          {
            path: "uiconfigure/sections/:sectionId/items",
            element: <ManageSectionItemsScreen />,
          },
          {
            path: "uiconfigure/sections/:sectionId/preview",
            element: <SectionPreviewScreen />,
          },

          {
            path: "offer/bundlescreen",
            element: <AdminBundleScreen />,
          },
          {
            path: "offer/bundlescreen/createbundlescreen",
            element: <AdminCreateBundlesScreen />,
          },
          {
            path: "offer/claimProduct",
            element: <AdminFreeProductScreen />,
          },
          {
            path: "offer/claimProduct/createclaimProduct/:id",
            element: <AdminCreateFreeProductScreen />,
          },
          {
            path: "pets",
            element: <AdminPetScreen />,
          },
          {
            path: "pets/editScreen",
            element: <AdminPetEditScreen />,
          },
          {
            path: "pets/addScreen",
            element: <AdminPetAddScreen />,
          },
          {
            path: "offer/adBanner",
            element: <AdminAdBanner />,
          },
          {
            path: "offer/CouponManagement",
            element: <CouponManagement />,
          },
          {
            path: "offer/adBanner/adBannerInnerSection",
            element: <AdminBannerInnerSection />,
          },
          {
            path: "offer/adBanner/adBannerInnerSection/adCreateNewBanner",
            element: <AdminCreateNewBanner />,
          },
          {
            path: "footer/Careers",
            element: <CareersManagement />,
          },
          {
            path: "footer/Blogs",
            element: <BlogManagement />,
          },
          {
            path: "categorymanagement",
            element: <CategoriesManagement />,
          },
          {
            path: "categorymanagement/addNewSubcategory",
            element: <AddNewSubCategory />,
          },
          {
            path: "footer/Careers/addNewCarrer",
            element: <AddNewCareersScreen />,
          },
          {
            path: "footer/Careers/addNewCarrer/:id",
            element: <AddNewCareersScreen />,
          },
          {
            path: "footer/Blogs/addnewBlog",
            element: <AddNewBlogScreen />,
          },
          {
            path: "footer/Blogs/addnewBlog/:id",
            element: <AddNewBlogScreen />,
          },
          {
            path: "footer/FAQ",
            element: <FAQAdmin />,
          },
          {
            path: "footer/footerList",
            element: <TermsAdmin />,
          },
          {
            path: "AdminBookingService",
            element: <AdminBookingService />,
          },
          {
            path: "adminsettings/adminsettings",
            element: <AdminSettings />,
          },
          {
            path: "AdminQueriesScreen",
            element: <AdminQueriesScreen />,
          },
          {
            path: "customerManagement/CustomerAdminScreen",
            element: <PetlandCustomerAdminScreen />,
          },
          {
            path: "customerManagement/AbandonedCart",
            element: <PetlandAbandonedCartScreen />,
          },
          {
            path: "adminEmailTemplates/EmailTemplates",
            element: <EmailManagementScreen />,
          },

          {
            path: "adminEmailTemplates/branding",
            element: <EmailManagementScreen />,
          },
          {
            path: "adminemailtemplates/layouts",
            element: <EmailManagementScreen />,
          },
          {
            path: "adminemailtemplates/layouts/create",
            element: <EmailLayoutDetailsScreen />,
          },
          {
            path: "adminemailtemplates/layouts/edit/:id",
            element: <EmailLayoutDetailsScreen />,
          },
          {
            path: "adminEmailTemplates/create",
            element: <EmailTemplateDetailsScreen />,
          },

          {
            path: "adminEmailTemplates/edit/:id",
            element: <EmailTemplateDetailsScreen />,
          },
          {
            path: "adminEmailTemplates/create",
            element: <EmailTemplateDetailsScreen />,
          },
          {
            path: "adminEmailTemplates/edit/:id",
            element: <EmailTemplateDetailsScreen />,
          },
          {
            path: "adminemailtemplates/branding",
            element: <EmailManagementScreen />,
          },

          {
            path: "adminemailtemplates/branding/create",
            element: <BrandingProfileDetailsScreen />,
          },

          {
            path: "adminemailtemplates/branding/edit/:id",
            element: <BrandingProfileDetailsScreen />,
          },

          {
            path: "adminemailtemplates/create",
            element: <EmailTemplateDetailsScreen />,
          },

          {
            path: "adminemailtemplates/edit/:id",
            element: <EmailTemplateDetailsScreen />,
          },

          {
            path: "adminEmailTemplates/layouts/create",
            element: <EmailLayoutDetailsScreen />,
          },
          {
            path: "adminEmailTemplates/layouts/edit/:id",
            element: <EmailLayoutDetailsScreen />,
          },
          {
            path: "adminemailtemplates/categories",
            element: <EmailManagementScreen />,
          },

          {
            path: "adminemailtemplates/categories/create",
            element: <EmailCategoryDetailsScreen />,
          },

          {
            path: "adminemailtemplates/categories/edit/:id",
            element: <EmailCategoryDetailsScreen />,
          },
        ],
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];
export default AdminRoutes;
